<template>
  <div class="login-container">
    <!-- 登录背景 -->
    <div class="login-background" :style="{ backgroundImage: `url(${backgroundImage})` }"></div>
    
    <!-- 登录表单容器 -->
    <div class="login-form-container">
      <!-- 标题 -->
      <div class="login-title">企业管理系统</div>
      
      <!-- 登录方式切换 -->
      <div class="login-tabs">
        <div 
          class="login-tab" 
          :class="{ active: loginType === 'password' }"
          @click="loginType = 'password'"
        >
          账号密码登录
        </div>
        <div 
          class="login-tab" 
          :class="{ active: loginType === 'dingtalk' }"
          @click="loginType = 'dingtalk'"
        >
          钉钉扫码登录
        </div>
      </div>
      
      <!-- 密码登录表单 -->
      <el-form 
        v-if="loginType === 'password'" 
        :model="loginForm" 
        :rules="loginRules" 
        ref="loginFormRef"
        class="password-login-form"
      >
        <!-- 手机号码 -->
        <el-form-item prop="username">
          <el-input 
            v-model="loginForm.username" 
            placeholder="请输入手机号码"
            prefix-icon="el-icon-mobile-phone"
            maxlength="11"
            show-word-limit
          ></el-input>
        </el-form-item>
        
        <!-- 密码 -->
        <el-form-item prop="password">
          <el-input 
            v-model="loginForm.password" 
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            type="password"
            show-password
          ></el-input>
        </el-form-item>
        
        <!-- 记住密码和忘记密码 -->
        <div class="login-options">
          <el-checkbox v-model="rememberPassword">记住密码</el-checkbox>
          <a href="#" class="forgot-password">忘记密码？</a>
        </div>
        
        <!-- 登录按钮 -->
        <el-form-item>
          <el-button 
            type="primary" 
            @click="handlePasswordLogin"
            round
            class="login-button"
          >
            登录
          </el-button>
        </el-form-item>
      </el-form>
      
      <!-- 钉钉扫码登录 -->
      <div v-else class="dingtalk-login-form">
        <div class="dingtalk-qrcode-container">
          <div class="qrcode-tip">请使用钉钉扫码登录</div>
          <div class="qrcode-image">
            <!-- 钉钉扫码登录的二维码，这里使用占位图，实际项目中需要替换为真实的钉钉登录二维码 -->
            <div class="qrcode-placeholder">
              <div class="qrcode-icon">📱</div>
              <div class="qrcode-text">钉钉扫码</div>
            </div>
          </div>
          <div class="qrcode-hint">打开钉钉，扫一扫登录</div>
        </div>
      </div>
      
      <!-- 底部提示 -->
      <div class="login-footer">
        <p>&copy; 2026 企业管理系统 - 版权所有</p>
      </div>
    </div>
  </div>
</template>

<script>
  import { login, getInited, register } from "@/api/public.js";
export default {
  name: 'LoginPage',
  data() {
    return {
      // 背景图片URL
      backgroundImage: 'https://cdn.cxc-group.com/admin/admin-login-back.png',
      // 登录类型：password-密码登录，dingtalk-钉钉登录
      loginType: 'password',
      // 登录表单
      loginForm: {
        username: '',
        password: ''
      },
      // 登录规则
      loginRules: {
        username: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          // pattern 要判断是否是手机号，如果是admin的时候，不校验手机号格式
          { pattern: /^1[3-9]\d{9}$|^admin$/, message: '请输入正确的手机号码或admin', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }
        ]
      },
      // 记住密码
      rememberPassword: false
    }
  },
  methods: {
    // 处理密码登录
    handlePasswordLogin() {
      this.$refs.loginFormRef.validate((valid) => {
        if (valid) {
          // 表单验证通过，执行登录逻辑
          // 使用Vuex的login action处理登录
          this.$store.dispatch('login', this.loginForm).then(() => {
            this.$message.success('登录成功')
            // 跳转到首页
            this.$router.push('/home')
          }).catch((error) => {
            this.$message.error('登录失败：' + (error.message || '请检查您的登录信息'))
          })
        } else {
          this.$message.error('请填写正确的登录信息')
          return false
        }
      })
    },
    // 切换登录方式
    toggleLoginType(type) {
      this.loginType = type
    }
  }
}
</script>

<style scoped>
/* 登录容器 */
.login-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 登录背景 */
.login-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  filter: brightness(0.8);
}

/* 登录表单容器 */
.login-form-container {
  position: relative;
  width: 400px;
  padding: 40px;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  z-index: 10;
}

/* 登录标题 */
.login-title {
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 30px;
  color: var(--text);
}

/* 登录方式切换 */
.login-tabs {
  display: flex;
  margin-bottom: 30px;
  border-bottom: 1px solid var(--border);
}

.login-tab {
  flex: 1;
  text-align: center;
  padding: 10px 0;
  cursor: pointer;
  font-size: 14px;
  color: var(--text-200);
  transition: all 0.3s ease;
  border-bottom: 2px solid transparent;
}

.login-tab.active {
  color: var(--primary);
  border-bottom-color: var(--primary);
  font-weight: 500;
}

.login-tab:hover {
  color: var(--primary);
}

/* 密码登录表单 */
.password-login-form {
  width: 100%;
}

/* 登录选项 */
.login-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  font-size: 14px;
}

.forgot-password {
  color: var(--primary);
  text-decoration: none;
  cursor: pointer;
}

.forgot-password:hover {
  text-decoration: underline;
}

/* 登录按钮 */
.login-button {
  width: 100%;
  height: 44px;
  font-size: 16px;
  background-color: var(--primary);
  border-color: var(--primary);
  color: var(--text);
  font-weight: 500;
}

.login-button:hover {
  background-color: var(--primary-200);
  border-color: var(--primary-200);
  color: var(--text);
}

/* 钉钉登录表单 */
.dingtalk-login-form {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.dingtalk-qrcode-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 20px;
}

.qrcode-tip {
  font-size: 16px;
  font-weight: 500;
  color: var(--text);
}

.qrcode-image {
  width: 200px;
  height: 200px;
  background-color: var(--bg-200);
  border: 1px solid var(--border);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.qrcode-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.qrcode-icon {
  font-size: 64px;
}

.qrcode-text {
  font-size: 14px;
  color: var(--text-200);
}

.qrcode-hint {
  font-size: 14px;
  color: var(--text-200);
}

/* 登录底部 */
.login-footer {
  margin-top: 30px;
  text-align: center;
  font-size: 12px;
  color: var(--text-200);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .login-form-container {
    width: 90%;
    padding: 30px 20px;
  }
  
  .login-title {
    font-size: 20px;
    margin-bottom: 20px;
  }
  
  .login-tabs {
    margin-bottom: 20px;
  }
  
  .qrcode-image {
    width: 150px;
    height: 150px;
  }
  
  .qrcode-icon {
    font-size: 48px;
  }
}
</style>